export class NotificationSettings {
  colorBoards: boolean
  projects: boolean
  newTask: boolean
  completedTask: boolean
  taskReminder: boolean
  taskReminderPeriod: number
  elementComments: boolean
  noteComments: boolean
  taskComments: boolean
}

interface SettingNode {
  toggled: boolean;
  visible: boolean;
  period?: number;
  innerToggles?: {
    [key: string]: SettingNode;
  };
}

interface KnownInnerToggles {
  colorBoards: SettingNode;
  projects: SettingNode;
  noteComments: SettingNode;
  elementComments: SettingNode;
  tasks: SettingNode & {
    innerToggles: {
      newTask: SettingNode;
      completedTasks: SettingNode;
      taskReminder: SettingNode;
      taskComments: SettingNode;
    };
  };
}

export interface EmailSettings {
  all: SettingNode & {
    innerToggles: KnownInnerToggles;
  };
}

export interface SettingItem {
  key: string;
  label: string;
  description?: string;
  visible?: boolean;
  isGroup?: boolean;
  checkVisibility?: boolean;
}
